module.exports = __webpack_public_path__ + "img/fe0f65e.svg";